if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    handleAnnouncementBar() {
      this.announcementBar = document.querySelector(
        '.js-announcement-bar'
      );

      if (!this.announcementBar) return;

      document.documentElement.style.setProperty(
        '--announcement-bar-top-position',
        `${parseInt(this.announcementBar.scrollHeight)}px`
      );
    }

    handleOffsets() {
      // this.rect =
      //   this.querySelector('header').getBoundingClientRect();
      this.offset = document.querySelector('header').clientHeight + 'px';

      document
        .querySelectorAll('[data-offset-top]')
        .forEach((element) => {
          element.style.setProperty(
            '--header-offset-top',
            this.offset
          );
        });

      document.documentElement.style.setProperty(
        '--header-offset-top',
        this.offset
      );
    }

    handleScroll() {
      const currentScroll = window.scrollY;
      const coefficient = 40;
      const isMenuOpen = this.querySelector('header').classList.contains('menu-open');

      let clientRect = this.dynamicTarget?.getBoundingClientRect();

      if (this.dynamicTarget)
        this.classList.toggle(
          'is-dynamic',
          //!(Math.abs(clientRect.top) > clientRect.height)
          !(Math.abs(clientRect.top) > 0)
        );

      let isDynamic = this.classList.contains('is-dynamic');

      if (this.section)
        this.section.classList.toggle(
          'sticky-top',
          window.scrollY > 0 && !isDynamic
        );

      this.classList.toggle(
        'is-scroll',
        window.scrollY > 0 && !isDynamic
      );

      if (!isMenuOpen && this.announcementBar && Math.abs(currentScroll - this.lastScrollTop) > coefficient) {
        const isUp = currentScroll > this.lastScrollTop;
        this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

        if (isUp) {
          this.announcementBar.classList.add('is-hidden');
        } else {
          this.announcementBar.classList.remove('is-hidden');
        }
      }
    }

    connectedCallback() {
      this.lastScrollTop = window.scrollY;

      this.dynamicTarget = document.querySelector(
        '[data-dynamic-header-target]'
      );
      this.section = this.closest('.shopify-section');

      this.handleScroll();

      window.addEventListener(
        'scroll',
        () => {
          this.handleScroll();
        },
        true
      );

      this.handleAnnouncementBar();
      this.handleOffsets();

      document.addEventListener("announcement-bar-open", () => {
        this.announcementBar.classList.remove('is-hidden');
      })

      window.addEventListener('resize', () => {
        this.handleAnnouncementBar();
        this.handleOffsets();
      });

      const langifySpan = document.querySelector(
        '.js-announcement-bar .ly-custom-1000'
      );

      if (!langifySpan) return;

      const observer = new MutationObserver(() => {
        this.handleAnnouncementBar();
        this.handleOffsets();
      });
      observer.observe(langifySpan, { childList: true });
    }
  }
  customElements.define('sticky-header', StickyHeader);
}
